import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import {
  WebDomEcommerceLogo,
  WebDomFintechLogo,
  WebDomHealthcareLogo,
  WebDomEducationLogo,
  WebDomSocialLogo,
  WebDomHospitalityLogo,
  WebDomEntertainmentLogo,
  WebDomGovernmentLogo,
  WebDomRealEstateLogo,
  WebDomBusinessLogo,
  WebDomOnDemandLogo,
  WebDomTechITLogo,
  WebDomNonProfitLogo,
  AndIndautomative,
  WebDomTourLogo,
  GameSportLogo,
  AndIndLogistics,
  AndIndSocial,
  AndIndTravel,
  AndIndAviation,
  AndIndITStaff,
  AndIndRetail,
} from "../../../app-constants";

function Domaindiversity() {
  return (
    <section className="domain_diversity p-100 blue_dark_sec">
      <Container>
        <Row>
          <Col
            xs={12}
            md={12}
            lg={10}
            xl={10}
            xxl={10}
            className="m-auto text-center"
          >
            <h2>
              Industries We Serve with Our Diverse
              <span> Android App Development Solutions</span>
            </h2>
            <p>
              Having expertise in diverse Android app development services, we
              facilitate multiple industries by creating a product that fits
              right according to their business needs.
            </p>
            <p>
              As a trusted custom Android app development company, we offer our
              revolutionary services to the following industries.
            </p>
          </Col>
        </Row>
        <Row>
          <Col xs={12} md={12} lg={12} xl={12} xxl={12}>
            <div className="domain_main">
              <div className="domain_item">
                <div className="domain_content">
                  {WebDomHealthcareLogo}
                  <h6>Healthcare</h6>
                </div>
              </div>
              <div className="domain_item">
                <div className="domain_content">
                  {WebDomFintechLogo}
                  <h6>Fintech</h6>
                </div>
              </div>
              <div className="domain_item">
                <div className="domain_content">
                  {AndIndautomative}
                  <h6>Automotive</h6>
                </div>
              </div>
              <div className="domain_item">
                <div className="domain_content">
                  {WebDomEcommerceLogo}
                  <h6>eCommerce</h6>
                </div>
              </div>
              <div className="domain_item">
                <div className="domain_content">
                  {AndIndLogistics}
                  <h6>Logistics</h6>
                </div>
              </div>
              <div className="domain_item">
                <div className="domain_content">
                  {AndIndSocial}
                  <h6>Social Networking</h6>
                </div>
              </div>
              <div className="domain_item">
                <div className="domain_content">
                  {GameSportLogo}
                  <h6>Game</h6>
                </div>
              </div>
              <div className="domain_item">
                <div className="domain_content">
                  {AndIndTravel}
                  <h6>Travel & Tourism</h6>
                </div>
              </div>
              <div className="domain_item">
                <div className="domain_content">
                  {AndIndAviation}
                  <h6>Aviation</h6>
                </div>
              </div>
              <div className="domain_item">
                <div className="domain_content">
                  {WebDomRealEstateLogo}
                  <h6>Real Estate</h6>
                </div>
              </div>
              <div className="domain_item">
                <div className="domain_content">
                  {WebDomEducationLogo}
                  <h6>Education</h6>
                </div>
              </div>
              <div className="domain_item">
                <div className="domain_content">
                  {WebDomOnDemandLogo}
                  <h6>Business</h6>
                </div>
              </div>
              <div className="domain_item">
                <div className="domain_content">
                  {WebDomEntertainmentLogo}
                  <h6>Music</h6>
                </div>
              </div>
              <div className="domain_item">
                <div className="domain_content">
                  {AndIndITStaff}
                  <h6>Sports</h6>
                </div>
              </div>
              <div className="domain_item">
                <div className="domain_content">
                  {AndIndRetail}
                  <h6>Retail</h6>
                </div>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Domaindiversity;
